var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-comment-edit"},[_c('CommentHeader',{attrs:{"comment":_vm.computedForm}}),_c('div',{staticClass:"c-comment-edit__body"},[_c('FormCommentCreate',{attrs:{"form":_vm.computedForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }